"use strict";

// "use strict";

jQuery(document).ready(function ($) {
  $('.tabs-block-button').on('click', function () {
    var $btn = $(this);
    var $wrapper = $btn.closest('.tabs-block');
    var targetId = $btn.data('target');

    // Remove active class from all buttons and wrappers
    $wrapper.find('.tabs-block-button').removeClass('active');
    $wrapper.find('.tabs-block-wrapper').removeClass('active').addClass('collapsed');

    // Add active class to clicked button and corresponding wrapper
    $btn.addClass('active');
    $wrapper.find('#' + targetId).removeClass('collapsed').addClass('active');
  });
});